import { GenericStore } from 'src/util/mobx/generic-store/generic.store'
import { addSkillCategory, addSkillSet, deleteExpectedRole, deleteSkillSet, getProfessionFields, getSkillCategory, getSkillSets } from '../api/skill-assessment-api'
import { GenericStoreAsyncMethod } from 'src/util/mobx/generic-store/decorator/async-method.decorator'
import { createStore } from 'src/util/mobx/generic-store/store-creator'
import { ProfessionFieldsType, SkillCategory } from '../model/skill-assessment-model'

export class skillAssessmentStore extends GenericStore {
  skillSets: SkillCategory[] | undefined
  professionsFieldsData: ProfessionFieldsType[] | undefined
  skillCategory: SkillCategory | undefined

  constructor() {
    super('skillAssessmentStore')

    super.observe(this)
    super.persist({ encrypt: false })
  }

  reset() {
    this.skillSets = undefined
    this.skillCategory = undefined
  }

  @GenericStoreAsyncMethod()
  async getSkillSets(userId?: string) {
    const data: any = await getSkillSets(userId)
    this.skillSets = data
  }

  @GenericStoreAsyncMethod()
  async getProfessionFields() {
    const data: ProfessionFieldsType[] = await getProfessionFields()
    this.professionsFieldsData = data
  }

  @GenericStoreAsyncMethod()
  async getSkillCategory(levelId: string) {
    const data: SkillCategory = await getSkillCategory(levelId)
    this.skillCategory = data
  }

  @GenericStoreAsyncMethod()
  async addSkillCategory(professionField: string, roleName: string, levelId: string) {
    await addSkillCategory(professionField, roleName, levelId)
  }

  @GenericStoreAsyncMethod()
  async deleteExpectedRole(levelId: string) {
    await deleteExpectedRole(levelId)
  }

  @GenericStoreAsyncMethod()
  async deleteSkillSet(setId: string, categoryId: string) {
    await deleteSkillSet(setId, categoryId)
  }

  @GenericStoreAsyncMethod()
  async addSkillSet(professionField: string, skillSetTitle: string, categoryId: string) {
    await addSkillSet(professionField, skillSetTitle, categoryId)
  }
}

export const {
  storeInstance: skillAssessmentStoreInstance,
  useStore: useSkillAssessmentStore,
} = createStore(new skillAssessmentStore())
